
import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

interface MousePosition {
  x: number;
  y: number;
}

export const InteractiveCard = () => {
  const [isHovered, setIsHovered] = useState<MousePosition | false>(false);

  const calculateTransform = (mousePosition: MousePosition) => {
    const rotateX = (mousePosition.y - 0.5) * 20;
    const rotateY = (mousePosition.x - 0.5) * 20;
    return `perspective(1000px) rotateX(${-rotateX}deg) rotateY(${rotateY}deg)`;
  };

  return (
    <div 
      id="card-container"
      className="relative h-[400px] w-[280px] sm:h-[500px] sm:w-[350px] mx-auto"
      onMouseMove={(e) => {
        const bounds = e.currentTarget.getBoundingClientRect();
        const x = (e.clientX - bounds.left) / bounds.width;
        const y = (e.clientY - bounds.top) / bounds.height;
        setIsHovered({ x, y });
      }}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="absolute inset-0 transition-transform duration-200 ease-out"
        style={{ 
          transform: isHovered ? calculateTransform(isHovered as MousePosition) : 'perspective(1000px) rotateX(0deg) rotateY(0deg)'
        }}
      >
        <div className="relative w-full h-full rounded-xl overflow-hidden shadow-2xl bg-black">
          <img 
            src="/lovable-uploads/76d2621f-bb9d-4d8b-81d4-9970a19e47a4.png" 
            alt="FOMO Illustration" 
            className="absolute inset-0 w-full h-full object-cover opacity-80"
          />
          
          <div className="absolute inset-0 p-4 flex flex-col justify-between">
            <div className="flex justify-between items-start">
              <div className="bg-black/50 backdrop-blur-sm rounded-full px-4 py-2 flex items-center gap-2 animate-float" style={{ animationDelay: '0.1s' }}>
                <Heart className="w-4 h-4 text-red-500" fill="currentColor" />
                <span className="text-white text-sm">1.2k</span>
              </div>
              
              <div className="bg-black/50 backdrop-blur-sm rounded-full px-4 py-2 animate-float" style={{ animationDelay: '0.2s' }}>
                <span className="text-white text-sm">🎁 Tip</span>
              </div>
            </div>
            
            <div>
              <h3 className="text-white text-xl font-bold mb-4">
                Create. Compete. Collect.
              </h3>
              
              <div className="flex items-center gap-3 bg-black/50 backdrop-blur-sm rounded-full px-4 py-2 w-fit animate-float" style={{ animationDelay: '0.3s' }}>
                <Avatar className="h-8 w-8">
                  <AvatarFallback className="bg-primary text-primary-foreground font-semibold">
                    F
                  </AvatarFallback>
                </Avatar>
                <span className="text-white text-sm">@fomo</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
